import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { FeatureFlagConfigurationState } from '@gea/digital-ui-lib';
import { filter, map, Observable, take } from 'rxjs';
import { ROUTE_NAMES } from '@brc/route-names';
import { FEATURE_FLAG } from '../utils';

export const LicensingGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(FeatureFlagConfigurationState.features).pipe(
    filter(Boolean),
    take(1),
    map((features): boolean | UrlTree => {
      if (features?.[FEATURE_FLAG.LICENSING]) {
        return true;
      }
      return router.createUrlTree([ROUTE_NAMES.FAULT_ANALYSIS]);
    })
  );
};
